import * as React from 'react';
import {
  Datagrid,
  TextField,
  List,
  FileField,
  DateField,
} from 'react-admin';

export const DocumentDivisionsList = (props) => {
  return (
    <List {...props} sort={{ field: 'name', order: 'desc' }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="division.name" label="Division Name" sortable={false} />
        <TextField source="title" sortable={false} />
        <TextField source="description" sortable={false} />
        {/* <ReferenceField reference="divisions" source="divisionId">
          <TextField source="name" />
        </ReferenceField> */}
        {/* <ReferenceField reference="admins" source="uploadedById">
          <TextField source="firstName" />
        </ReferenceField> */}
        {/* <TextField source="divisionId" label="divisionId"/> */}
        <TextField source="uploadedBy" sortable={false} />
        <FileField
          source="fileLocation[0]"
          title="title"
          target="_blank"
          download={true}
          label="File Location"
          sortable={false}
        />
        <DateField source="uploadedAt" />
      </Datagrid>
    </List>
  );
};
